import React from "react";
import { Modal, Button, Input, Spin } from "antd";
import { useWidth } from "../../hooks";

const { TextArea } = Input;

export function FundamentacaoModal({
  visible,
  onClose,
  title,
  fundamentacao,
  loading,
}) {
  const { width } = useWidth();

  return (
    <Modal
      title={title}
      width={width > 1280 ? "45vw" : "60vw"}
      centered
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose} type="primary">
          confirmar
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <TextArea rows={4} autoSize value={fundamentacao} readOnly />
      </Spin>
    </Modal>
  );
}
